/**
 * @generated SignedSource<<1c1cf999753d2e16592694da31f82d09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingContent_note$data = {
  readonly __typename: string;
  readonly eventGuid?: string | null;
  readonly id: string;
  readonly viewerCanEdit?: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"FloatingRecordingControls_note" | "HighlightsPanel_note" | "MeetingContainerModalNote_note" | "MeetingHeader_note" | "MeetingNote_note" | "StatsPanel_note" | "TranscriptModalContent_note" | "TranscriptPanel_note" | "useShouldShowRecapTab_note" | "utils_useMeetingRecorderStatus_note">;
  readonly " $fragmentType": "MeetingContent_note";
};
export type MeetingContent_note$key = {
  readonly " $data"?: MeetingContent_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingContent_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingContent_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanEdit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventGuid",
          "storageKey": null
        }
      ],
      "type": "Note",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "utils_useMeetingRecorderStatus_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranscriptModalContent_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranscriptPanel_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingContainerModalNote_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingNote_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldShowRecapTab_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingHeader_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FloatingRecordingControls_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HighlightsPanel_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StatsPanel_note"
    }
  ],
  "type": "INote",
  "abstractKey": "__isINote"
};

(node as any).hash = "6d680dcca95911a3d965ecb41eee3817";

export default node;
